//商品テンプレート 必須チェック

function checkfunction() {
  var check = document.getElementById("agree");
  var alert = document.getElementById("requiments-alert");
  var message = document.querySelector(".product-form__submit");
    if (check && check.checked == true) {
      message.disabled = !checkQtyValidity();
      if (alert) alert.style.display = "none";
      message.style.pointerEvents = "auto";
      return;
    }
    else {
      if (alert) alert.style.display = "block";
      message.disabled = !checkQtyValidity();
      message.style.pointerEvents = "auto";
    }
}

// checkfunction();
window.setTimeout(checkfunction, 1000);

function getCheckboxValue(agree){
  //チェック状態を取得する
  var obj = document.getElementById('agree');
  var result = obj.checked;
  var alert = document.getElementById("requiments-alert");

  // Alertで表示する
  if(result){
    alert.style.display = "none";
  }else{
    alert.style.display = "block";
  }
}


function checkErrorQuantity() {
  checkfunction();
  if (!checkQtyValidity()) {
      showErrorQtyMessage();
  } else {
      hideErrorQtyMessage();
  }
}
function checkQtyValidity() {
  return Number.isInteger(Number(document.querySelector('.quantity__input')?.value));
}
function showErrorQtyMessage() {
  const oldErrorMessage = document.querySelector('.qty-error-msg');
  if (oldErrorMessage) return;

  const errorMessage = document.createElement('span');
  errorMessage.className = 'qty-error-msg';
  errorMessage.innerHTML = '必ず整数で入力ください';
  errorMessage.style.color = 'red';
  document.querySelector('.product-form__quantity').appendChild(errorMessage);
}
function hideErrorQtyMessage() {
  const errorMessage = document.querySelector('.qty-error-msg');
  if (errorMessage) {
      errorMessage.remove();
  }
}